import { useRef, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';

import { Loader } from '@components';
import { usersQuery, userMutation } from '@queries';
import { ButtonSpinnerDarkIcon, MoreHorizontalIcon, UserIcon } from '@svgs';

const User = ({ user }) => {
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();
  const queryClient = useQueryClient();

  // menu activation
  const dropdownMenu = useRef(null);
  const [showDropdownMenu, setShowDropdownMenu] = useState(false);
  const closeOpenMenus = (e) => {
    if (showDropdownMenu && !dropdownMenu.current?.contains(e.target)) {
      setShowDropdownMenu(false);
    }
  };
  document.addEventListener('mousedown', closeOpenMenus);

  // save user
  const mutation = useMutation(
    userMutation(user.id, {
      onSuccess: (data) => {
        // invalidate user lists and detail
        queryClient.invalidateQueries({
          queryKey: ['users', 'detail', user.id],
        });
        queryClient.invalidateQueries({ queryKey: ['users', 'list'] });
        navigate(`/dashboard/users/${user.id}`);
      },
    }),
  );

  return (
    <div className="sb-row-item">
      <div>
        <p>User</p>
      </div>
      <div>
        <p>
          {!user.is_active && (
            <>
              {user.first_name} {user.last_name}
            </>
          )}
          {user.is_active && (
            <Link to={`/dashboard/users/${user.id}`} title={user.display_url}>
              {user.first_name} {user.last_name}
            </Link>
          )}
        </p>
      </div>
      <div>{user.email}</div>
      <div>{user.is_active ? 'Active user' : 'Disabled user'}</div>
      {!user.is_active && (
        <div className="sb-options">
          {mutation.isPending && <ButtonSpinnerDarkIcon />}
          {!mutation.isPending && (
            <>
              <button
                className="sb-page-options-menu-trigger sb-options-trigger"
                onClick={() => setShowDropdownMenu(!showDropdownMenu)}
              >
                <MoreHorizontalIcon />
              </button>
              <div
                ref={dropdownMenu}
                className={
                  'sb-options-menu ' +
                  (showDropdownMenu ? 'sb-show' : 'sb-hide')
                }
              >
                <div className="sb-options-menu-content">
                  <button
                    type="button"
                    className="sb-options-item"
                    onClick={() => mutation.mutate({ is_active: true })}
                  >
                    <UserIcon />
                    {t('Re-activate user')}
                  </button>
                </div>
              </div>
            </>
          )}
        </div>
      )}
    </div>
  );
};

export const SearchUsers = ({ searchDisabled = false, searchTerm }) => {
  // Fetch users
  const {
    data: usersData,
    isPending: usersIsPending,
    isError,
  } = useQuery(
    usersQuery({
      q: searchTerm,
      is_active: searchDisabled ? 0 : 1,
      limit: 500,
      order_by: 'first_name',
    }),
  );

  return (
    <>
      {usersIsPending && <Loader className="sb-loader sb-loader-block" />}
      {!usersIsPending && usersData.objects.length === 0 && (
        <p>No users found</p>
      )}
      {!usersIsPending && usersData.objects.length > 0 && (
        <>
          <div className="sb-content-view-row">
            {usersData.objects.map((user) => {
              return <User key={user.id} user={user} />;
            })}
          </div>
        </>
      )}
    </>
  );
};
